import React, { useState } from 'react'
import { Modal } from '../ui/Modal'
import { Button } from '../ui/Button'
import { useAuth } from '../auth/AuthContext'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

interface ContinueLaterModalProps {
  onConfirm?: () => void
  disabled?: boolean
}

const ContinueLaterModal: React.FC<ContinueLaterModalProps> = ({
  onConfirm,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  const handleConfirm = () => {
    setIsOpen(false)
    logout()
    toast.success('Sesión cerrada correctamente')
    navigate('/login')

    onConfirm?.()
  }

  return (
    <>
      {/* Botón que abre el modal */}
      <Button
        type="button"
        variant="secondary"
        onClick={handleOpenModal}
        className="w-full sm:w-auto"
        disabled={disabled}
      >
        Continuar después
      </Button>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={handleCloseModal} size="md">
        <div className="p-6 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-8 h-8 text-orange-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Continuar más tarde
            </h3>

            <p className="text-gray-600 text-sm leading-relaxed">
              Tu progreso se guardará automáticamente. Podrás continuar tu
              solicitud de arrendamiento desde donde la dejaste en cualquier
              momento.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="secondary"
              onClick={handleCloseModal}
              className="sm:order-1"
            >
              Cerrar
            </Button>

            <Button
              variant="primary"
              onClick={handleConfirm}
              className="sm:order-2"
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ContinueLaterModal
